import { createContext } from 'react';
import { CorpUIResponse } from 'src/types/Corp';

export interface CorporateFormContextType {
  isEditPage: boolean;
  corpData: CorpUIResponse;
  isParentPage: boolean;
  isChildPage: boolean;
}

export const CorporateFormContext =
  createContext<CorporateFormContextType | null>(null);
